import React from "react";

//Will display details about updates to the database made by clients, including payments made, account(s) activation, client notes, etc. 
const NOTIFICATIONS = () => {
    return (
        <div></div>
    )
}

export default NOTIFICATIONS;